import { render, staticRenderFns } from "./HistoryNotice.vue?vue&type=template&id=b7b4abf2&scoped=true&"
import script from "./HistoryNotice.vue?vue&type=script&lang=js&"
export * from "./HistoryNotice.vue?vue&type=script&lang=js&"
import style0 from "./HistoryNotice.vue?vue&type=style&index=0&id=b7b4abf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b4abf2",
  null
  
)

export default component.exports